import { headers, URL } from "./login";

const getCardType =(token) => {
    return "VISA";
    const first = +token.substring(1, 2)
    const second = +token.substring(2, 3)
    let cardType;
    switch (first) {
        case 4: cardType = "VISA"; break
        case 5: cardType = "MASTERCARD"; break
        case 3:{
            switch (second) {
                case 7: cardType = "AMERICANEXPRESS"; break
                case 0, 8: cardType = "DINERS"; break;
                default: cardType = "JCB"
            }
        } 
        default: cardType ="DISCOVER";
    }

    return cardType
}

export const executeTrx = async (accessToken, details) => {

    let body = {
        "contextRequest": {},
        "details": {
            "name": "NONACCOUNT",
            "details":{
                "name": "CVT",
                "field":[
                    {
                        "key":"SP_accountNumberClear",
                        "value": details.cardConnectToken
                    }, 
                    {
                        "key":"IS_CARD_TOKENIZED",
                        "value": details.cvv === undefined?"YES":"NO"
                    },
                    {
                        "key":"RSP_AC_CARD_TYPE",
                        "value": getCardType(details.cardConnectToken)
                    },
                    {
                        "key":"STORE_CUSTOMER_PROFILE",
                        "value":"NO"
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_FULL_NAME",
                        "value": details.name
                    },
                    {
                        "key":"AMOUNT",
                        "value":details.amount
                    },
                    {
                        "key":"CURRENCY_CODE",
                        "value":"840"
                    },
                    {
                        "key":"RSP_AC_EXPIRE_MONTH",
                        "value": details.month
                    },
                    {
                        "key":"RSP_AC_EXPIRE_YEAR",
                        "value": details.year
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_ADDRESS_LINE1",
                        "value": details.billingAddress
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_ADDRESS_CITY",
                        "value":details.city
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_ADDRESS_STATE",
                        "value": details.state
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_ADDRESS_COUNTRY",
                        "value":"US"
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_ADDRESS_POSTALCODE",
                        "value":details.zip
                    },
                    {
                        "key":"RSP_AC_CARD_HOLDER_EMAIL",
                        "value": details.email
                    }
                ]
            }
        }
    }

    if(details.cvv !== undefined)
        body.details.details.field.push({
            'key': 'SP_AC_CREDIT_CARD_CVV',
            'value': details.cvv
        })

        console.log(JSON.stringify(body))

    const response = await fetch(URL + "fundz-ms/user/executeTrx", {
        method: "POST",
        headers: Object.assign({}, headers, {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken.access_token}`
        }),
        body: JSON.stringify(body),
    }).then(response => response.text())
    .catch(error => "Please try it again.");

    return response
}
